export default () => ({
  open: false,

  hide() {
    this.open = false;
    setTimeout(() => this.toggleBodyClass(false), 500);
  },

  show() {
    this.open = true;
    this.toggleBodyClass(true);
  },

  toggleBodyClass(addBodyClass) {
    const body = document.querySelector("body");
    if (addBodyClass) {
      body.classList.add("modal-open");
    } else {
      body.classList.remove("modal-open");
    }
  },
});
